// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5fPTR","footer":"styles_footer__3ujQ4"};